import { FunctionalComponent, h } from 'preact'
import EventDateFormatter from './EventDateFormatter'
import { UserData } from './EventAttendees'
import EventAttendeesPreview from './EventAttendeesPreview'
import classnames from 'classnames'
import Icon from '../assets'
import Phrase from '../../libs/translationsUtils/phrase'
import { common } from '../common'

interface Event {
  id?: number
  image?: string
  startAt: number
  endAt: number
  title: string
  destinationUrl: string
  location?: string
  type?: string
  objectID?: string
  attendees?: UserData[]
  attendeeCount?: number
  isLoggedInUserAttendee?: boolean
}

interface EventPresentation extends Event {
  isFullWidth?: boolean
  isFeatured?: boolean
  key?: number
}

interface Props {
  eventList: Event[]
  className: string
}

const EventListView = ({ eventList, className }: Props) => {
  return (
    <div className={className}>
      {eventList.map((event) => (
        <EventListItemView key={event.id} {...event} />
      ))}
    </div>
  )
}

export const EventListItemView = ({
  id,
  title,
  type,
  startAt,
  endAt,
  image,
  location,
  destinationUrl,
  attendees,
  attendeeCount,
  isLoggedInUserAttendee,
  isFeatured,
  isFullWidth
}: EventPresentation) => {
  const formattedStartAt = EventDateFormatter.formatStartAtForOverviewList(startAt)
  const isPastEvent = EventDateFormatter.isPastEvent(endAt)
  const isEventEngagementEnabled = common.isModuleActive('eventEngagement')
  const hrefClassName = `event-list-item__url qa-event-list-item-url qa-event-${id ?? ''}`
  return (
    <a href={destinationUrl} className={hrefClassName}>
      <div
        className={classnames({
          'featured-event__item': image && isFeatured && !isFullWidth,
          'event-list-item-container': image,
          'topic-view': !isFeatured,
          'event-list-item-details-full-width': !image,
          'card-widget-wrapper': true
        })}
      >
        {image && (
          <div className='event-item-image-container'>
            {type && <EventPill className='event-item__type' type={type} past={isPastEvent} />}
            <div className='event-item__image' style={{ backgroundImage: `url(${image})` }} />
          </div>
        )}
        <div className='event-item-detail-container'>
          <div
            className={classnames('event-item__date', {
              event__date_past: isPastEvent
            })}
          >
            {formattedStartAt}
          </div>
          <h3 className='event-item__title'>
            {type && !image && (
              <EventPill className='event-detail-item__type' type={type} past={isPastEvent} />
            )}
            <a href={destinationUrl} className='event-item__title qa-event-title card-widget-title'>
              {title}
            </a>
          </h3>
          {location ? <PeopleLocation /> : <OnlineLocation />}
          <EventAttendeesPreview
            isPastEvent={isPastEvent}
            attendeeCount={attendeeCount}
            attendees={attendees}
            isLoggedInUserAttendee={isLoggedInUserAttendee}
            isEventEngagementEnabled={isEventEngagementEnabled}
          />
        </div>
      </div>
    </a>
  )
}

export interface EventPillProps {
  className?: string
  past: boolean
  type: string
}

const EventPill: FunctionalComponent<EventPillProps> = ({ className, past, type }) => {
  return (
    <span
      className={classnames(
        className,
        'pill',
        'pill--uppercase',
        'pill--article',
        'qa-content-type-pill',
        {
          'event-pill__past': past
        }
      )}
    >
      {type}
    </span>
  )
}

const OnlineLocation = () => (
  <div className='event-item__location'>
    <div className='event-item__location_icon'>
      <Icon icon='computer' />{' '}
    </div>
    <div>
      <Phrase p='events.location.online' m='Forum' />
    </div>
  </div>
)

const PeopleLocation = () => (
  <div className='event-item__location'>
    <div className='event-item__location_icon'>
      <Icon icon='people' />{' '}
    </div>
    <div>
      <Phrase p='events.location.in.person' m='Forum' />
    </div>
  </div>
)

export default EventListView
